<template>
  <div class="card">
    <div class="card-header">
      <a
        class
        data-toggle="collapse"
        :href="`#${collapseName}`"
        role="button"
        aria-expanded="false"
        :aria-controls="collapseName"
      >
        <div class="row">
          <div class="col">
            <h3 class="card-header-title">
              <slot name="title"/>
            </h3>
          </div>
          <div class="col-auto">
            <span class="collapse-marker">
              Hide / Show
              <font-awesome :icon="['fas', 'chevron-down']" fixed-width/>
            </span>
          </div>
        </div>
        <!-- /.row -->
      </a>
    </div>
    <div class="collapse show" :id="collapseName">
      <div class="card-body card-body-info">
        <slot/>
      </div>
    </div>
    <!-- /.collapse -->
  </div>
  <!-- /.card -->
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String
    }
  },

  computed: {
    collapseName () {
      return `collapse${this.name}`
    }
  }
}
</script>
